import moment from "moment-timezone";

/**
 * Helper for formatting the xAxis date text
 */
export const formattedXAxisDate = (date: Date, dateFormat: "day" | "month" | undefined): string => {
  if (dateFormat === "day") {
    return moment.utc(date).format("Do MMM");
  }

  return moment.utc(date).format("MMM-YYYY");
};
